import React from 'react';
import {useNavigate} from 'react-router-dom'

export const Cocktail = ({singleCocktail}) => {
  const navigate = useNavigate();
  
  const saveCocktail = async()=>{
    const cocktailAPI = `https://cokctail.herokuapp.com/drinks`
    const response = await fetch(cocktailAPI,
    {
      method:'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        name:singleCocktail.strDrink,
        image:singleCocktail.strDrinkThumb,
        ingridients:`${singleCocktail?.strIngredient1},${singleCocktail?.strIngredient2},${singleCocktail?.strIngredient3},${singleCocktail?.strIngredient4}`,
        instructions:singleCocktail.strInstructions
      })
    });
    const data = await response.json()
    console.log(data.payload)
    alert('Cocktail Saved✅')
    navigate("/")
  }



  return (
    <div className=' grid lg:grid-cols-2 md:grid-cols-2 gap-5 m-1'>
      <div>
      <h1 className=' text-5xl'>{singleCocktail.strDrink}</h1> 
      <img alt='-' src={singleCocktail.strDrinkThumb} className=' bg-contain card-container rounded-xl border-none cursor-pointer content-center' style={{width:'80%',height:'80%'}}/>
      </div>
            <div style={{fontSize:'70%',fontFamily:'fantasy'}}>
                <h2 className='text-5xl'>Ingredients</h2>
                <br/>
                <div className=' bg-amber-300'>
                  <ul className=' text-3xl'>
                    <li>{singleCocktail?.strIngredient1}</li>
                    <li>{singleCocktail?.strIngredient2}</li>
                    <li>{singleCocktail?.strIngredient3}</li>
                    <li>{singleCocktail?.strIngredient4}</li>
                    <li>{singleCocktail?.strIngredient5}</li> 
                  </ul>
                </div>
                <hr/>
                <div className=' bg-amber-400'>
                  <p className='text-5xl'>Instruction</p>
                  <p className='text-3xl font-light'>
                    {singleCocktail.strInstructions}
                  </p>
                </div>
                <hr/>
                <div className=' bg-amber-500'>
                  <p className='text-5xl'>
                    Step by step video
                  </p>
                  {singleCocktail.strVideo!==null ? (<video loop autoPlay>
                   <source
                     src={singleCocktail.strVideo}
                     type="video/mp4"
                  />
                   Your browser does not support the video tag.
                  </video>): (<p className='text-3xl font-light'>⛔️No video available⛔️</p>)}
                </div>
                <br></br>
                  <div className=' bg-yellow-200'>
                    <button className='text-3xl font-light'onClick={saveCocktail}>➕Add to your cocktail favourite list➕</button>
                  </div>
              </div> 
                  
                  
    </div>
  )
}

